import React, { useState } from "react";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/20/solid";

const LocationFilters = ({ localizaciones, filtroLocalizacion, setFiltroLocalizacion }) => {
    const [busqueda, setBusqueda] = useState("");
    const [provinciasAbiertas, setProvinciasAbiertas] = useState({});
    const [municipiosAbiertos, setMunicipiosAbiertos] = useState({});

    const handleBusqueda = (e) => {
        setBusqueda(e.target.value.toLowerCase());
    };

    const toggleProvincia = (nombre) => {
        setProvinciasAbiertas((prev) => ({
            ...prev,
            [nombre]: !prev[nombre],
        }));
    };

    const toggleMunicipio = (clave) => {
        setMunicipiosAbiertos((prev) => ({
            ...prev,
            [clave]: !prev[clave],
        }));
    };

    const filtrar = (provincia, municipio, distrito) => {
        const texto = `${provincia} ${municipio} ${distrito || ""}`.toLowerCase();
        return texto.includes(busqueda);
    };

    const toggleLocalizacion = (id) => {
        setFiltroLocalizacion((prev) =>
            prev.includes(id) ? prev.filter((l) => l !== id) : [...prev, id]
        );
    };

    return (
        <div className="bg-white rounded-md p-4 border border-gray-200 shadow-sm max-h-[50vh] overflow-y-auto">
            <h2 className="text-sm font-medium mb-2 text-gray-700">Ubicación</h2>

            <div className="relative mb-3">
                <input
                    type="text"
                    placeholder="Buscar ubicación..."
                    value={busqueda}
                    onChange={handleBusqueda}
                    className="w-full px-3 py-1 pr-8 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring"
                />
                {busqueda && (
                    <button
                        onClick={() => setBusqueda("")}
                        className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
                    >
                        ×
                    </button>
                )}
            </div>

            <div className="space-y-3">
                {localizaciones.map(({ provincia, municipios }) => {
                    const municipiosFiltrados = municipios.filter(({ municipio, localizaciones }) =>
                        localizaciones.some((loc) => filtrar(provincia, municipio, loc.distrito))
                    );

                    if (busqueda && municipiosFiltrados.length === 0) return null;

                    const isAbierta = busqueda
                        ? municipiosFiltrados.length > 0
                        : provinciasAbiertas[provincia];

                    return (
                        <div key={provincia}>
                            <button
                                onClick={() => toggleProvincia(provincia)}
                                className="w-full text-left text-sm font-semibold text-blue-700 hover:underline"
                            >
                                {provincia}
                            </button>

                            {isAbierta && (
                                <div className="mt-1 space-y-2">
                                    {municipiosFiltrados.map(({ municipio, localizaciones }) => {
                                        const claveMunicipio = `${provincia}-${municipio}`;
                                        const isDesplegable = localizaciones.length > 1;
                                        const isMunAbierto = busqueda
                                            ? localizaciones.some((loc) => filtrar(provincia, municipio, loc.distrito))
                                            : municipiosAbiertos[claveMunicipio];

                                        return (
                                            <div key={claveMunicipio} className="mb-2">
                                                {isDesplegable ? (
                                                    <>
                                                        <button
                                                            onClick={() => toggleMunicipio(claveMunicipio)}
                                                            className="text-xs text-gray-700 font-medium hover:underline flex items-center gap-1 ml-2"
                                                        >
                                                            <span>{municipio}</span>
                                                            {isMunAbierto ? (
                                                                <ChevronUpIcon className="w-4 h-4 text-gray-500 ml-1 inline-block" />
                                                            ) : (
                                                                <ChevronDownIcon className="w-4 h-4 text-gray-500 ml-1 inline-block" />
                                                            )}
                                                        </button>

                                                        {isMunAbierto && (
                                                            <div className="ml-4 mt-1 p-2 border border-gray-300 bg-gray-50 rounded-md flex flex-wrap gap-1">
                                                                {localizaciones
                                                                    .filter((loc) =>
                                                                        filtrar(provincia, municipio, loc.distrito)
                                                                    )
                                                                    .map((loc) => (
                                                                        <button
                                                                            key={loc.id}
                                                                            onClick={() => toggleLocalizacion(loc.id)}
                                                                            className={`flex items-center text-xs px-3 py-1 rounded-full border transition ${
                                                                                filtroLocalizacion.includes(loc.id)
                                                                                    ? "bg-blue-600 text-white"
                                                                                    : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                                                                            }`}
                                                                        >
                                                                            {loc.distrito || municipio}
                                                                            {filtroLocalizacion.includes(loc.id) && (
                                                                                <span className="ml-1 text-white font-bold">×</span>
                                                                            )}
                                                                        </button>
                                                                    ))}
                                                            </div>
                                                        )}
                                                    </>
                                                ) : (
                                                    <div className="flex flex-wrap gap-1">
                                                        {localizaciones
                                                            .filter((loc) =>
                                                                filtrar(provincia, municipio, loc.distrito)
                                                            )
                                                            .map((loc) => (
                                                                <button
                                                                    key={loc.id}
                                                                    onClick={() => toggleLocalizacion(loc.id)}
                                                                    className={`flex items-center text-xs px-3 py-1 rounded-full border transition ${
                                                                        filtroLocalizacion.includes(loc.id)
                                                                            ? "bg-blue-600 text-white"
                                                                            : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                                                                    }`}
                                                                >
                                                                    {loc.distrito || municipio}
                                                                    {filtroLocalizacion.includes(loc.id) && (
                                                                        <span className="ml-1 text-white font-bold">×</span>
                                                                    )}
                                                                </button>
                                                            ))}
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default LocationFilters;
